import date from 'quasar/src/utils/date.js';;
import Logger from 'js-logger';
var formatDate = date.formatDate;
Logger.useDefaults({
  // Only log messages during development or when DEBUG_LOGGING environment variable is true
  defaultLevel: process.env.DEV || process.env.DEBUG_LOGGING ? Logger.TRACE : Logger.OFF,
  // Prefix messages with date and time
  formatter: function formatter(messages, context) {
    var format = 'ddd Do MMM YYYY @ H:mm:ss -';
    messages.unshift(formatDate(new Date(), format));
  }
});
export default window.Logger = Logger;